export default __webpack_public_path__ + "static/media/Arm_right.defa9943.svg";